import * as React from 'react';
import { Avatar, UIHeading4, UIText3 } from '@cian/ui-kit';

import { IBuilder, ISeller } from '../../../types/newbuildingsCompare';
import { SellerPhone } from '../../../containers/NewbuildingCallToAction/SellerPhone';
import { isValidPhoneObject } from '../../../utils/phone/isValidPhoneObject';
import * as style from './Seller.css';

export interface ISellerProps {
  builderOrSeller: IBuilder | ISeller;
  isBuilder: boolean;
  isContactTypeHidden: boolean;
  newbuildingId: number;
  url: string;
  onShowPhone?: () => void;
}

export const Seller: React.FC<ISellerProps> = ({
  builderOrSeller,
  isBuilder,
  isContactTypeHidden,
  newbuildingId,
  url,
  onShowPhone,
}) => {
  const { name, logoUrl, offersForSale, phone } = builderOrSeller;
  const title = isBuilder ? 'Застройщик' : 'Агентство недвижимости';

  return (
    <div className={style['container']}>
      <div className={style['seller']}>
        <div className={style['seller-logo']}>
          <Avatar hideBorder size={44} src={logoUrl} type={isBuilder ? 'builder' : 'agency'} />
        </div>
        <div className={style['seller-info']}>
          {!isContactTypeHidden && <UIText3>{title}</UIText3>}
          <div className={style['seller-name']}>
            <UIHeading4 as="h4">{name}</UIHeading4>
          </div>
          {offersForSale && <UIText3>{offersForSale}</UIText3>}
        </div>
      </div>

      {isValidPhoneObject({ phone }) && (
        <SellerPhone
          isBuilder={isBuilder}
          newbuildingId={newbuildingId}
          onShowPhone={onShowPhone}
          target={builderOrSeller}
          url={url}
        />
      )}
    </div>
  );
};
